import React from 'react';
import "./Mentalhealth.css"
const MentalHealthVideos = () => {
  return (
    <div className="mental-health-videos">
      <h2>Mental Health Videos</h2>
      <div className="video-grid">
      
        <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Ix73CLI0Mo0?si=3jqbzJyjTE7s4dDm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>Meditation for Stress</h3>
          
          </div>
        </div>
        <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/79r4jlECyTs?si=KfajLwoE7aIUyCL3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>7-Minute Guided Meditation with a Mental Health Expert for Slowing Thoughts & Returning to Present</h3>
          
          </div>
        </div>
        <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/xRxT9cOKiM8?si=dRckkW5ZkklyMylj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>10-Minute Meditation For Depression</h3>
          
          </div>
        </div>
        <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/lRSB4n3wxCA?si=B4HpTbIRiQObWSAc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>Guided Meditation for Deep Relaxation, Managing Anxiety, Releasing Stress, Mental Health</h3>
            
          </div>
        </div>
        <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/ga-MniJxQz8?si=BTCD1acmG6fnntgR" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>Overcome Depression & Anxiety - Motivational Video - World Mental Health Day</h3>
         
          </div>
        </div>
        <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/2NZDp0E-HFc?si=8wi9O6iaobqRJDWv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>WHEN YOU FEEL LIKE QUITTING - Best Inspiring Speech on Mental Health</h3>
           
          </div>
        </div>
        <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Ix73CLI0Mo0?si=3jqbzJyjTE7s4dDm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>Meditation for Stress</h3>
          
          </div>
        </div>  <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Ix73CLI0Mo0?si=3jqbzJyjTE7s4dDm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>Meditation for Stress</h3>
          
          </div>
        </div>  <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Ix73CLI0Mo0?si=3jqbzJyjTE7s4dDm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>Meditation for Stress</h3>
          
          </div>
        </div>  <div className="video-card">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Ix73CLI0Mo0?si=3jqbzJyjTE7s4dDm" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <div className="video-info">
            <h3>Meditation for Stress</h3>
          
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentalHealthVideos;
